<svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.5 1L1.74808 10.168C1.15434 10.5638 1.15434 11.4362 1.74808 11.8321L15.5 21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="0.2 0.2"/>
</svg>
